import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Input,
  Col,
  Form,
  FormGroup,
  Label
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button, Statistics, BillsTable } from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const ESTADO_FACTURA = "estado-factura";
const ENVIO = "envio";
const NOTA = "nota";
const INTERNET = "internet";
const AGREGAR_MOVIL = "agregar-movil";
const GASTO_EXTRA = "gasto-extra";

const PILL_TODAS = "todas";
const PILL_DEVUELTAS = "devueltas";
const PERMISSIONS = [
  118946,
  118060,
  469,
  1
];
const ITEMS_PER_PAGE = [
  {
    value: 10,
    label: 10
  },
  {
    value: 20,
    label: 20
  },
  {
    value: 50,
    label: 50
  },
  {
    value: 100,
    label: 100
  },
  {
    value: 200,
    label: 200
  },
  {
    value: 1000,
    label: 1000
  },
  {
    value: 5000,
    label: 5000
  }
];

class BillsReturnedList extends React.Component {
  constructor(props) {
    super(props);
    if (!props.userData.isBillingDepartmentN1()) this.redirectTo("/dashboard");
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: "",
      showPopUp: false,
      popUpConfirmation: null,
      popUpToShow: null,
      currentBillStatus: null,
      currentBillID: "",
      currentBillNumber: "",
      currentPill: PILL_TODAS,
      showItems: null,
      page: 1,
      pageItems: 10
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.getViewArticlesButton = this.getViewArticlesButton.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.searchBills = this.searchBills.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.createBillStatusPopUp = this.createBillStatusPopUp.bind(this);
    this.editBillStatusConfirmation = this.editBillStatusConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.paymentStatus = this.paymentStatus.bind(this);
    this.openBillStatusPopUpFromBill = this.openBillStatusPopUpFromBill.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createNavigationPills = this.createNavigationPills.bind(this);
    this.createSelectedPillContent = this.createSelectedPillContent.bind(this);
    this.redirectTo = this.redirectTo.bind(this);

    this.listReturnedBills = this.listReturnedBills.bind(this);
    this.getGlobalBillingStatus = this.getGlobalBillingStatus.bind(this);
    this.createOrdersTable = this.createOrdersTable.bind(this);
    this.reloadOrder = this.reloadOrder.bind(this);
    this.buildFilter = this.buildFilter.bind(this);
    this.filterBills = this.filterBills.bind(this);
  }
  componentDidMount() {
    this.getGlobalBillingStatus("RETURNED");
    let search = {
      page: this.state.page,
      page_items: this.state.pageItems
    };
    this.listReturnedBills(search);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      let search = {
        page: this.state.page,
        page_items: this.state.pageItems,
        search: this.state.search
      };
      this.listReturnedBills(search);
    }
    if (prevState.pageItems !== this.state.pageItems) {
      let search = {
        page: this.state.page,
        page_items: this.state.pageItems,
        search: this.state.search
      };
      this.listReturnedBills(search);
    }
  }
  reloadOrder(orderId) {
    this.props.userData.getOrder(orderId).then(result => {
        console.log("################## RESPUESTA RELOAD ORDER ################");
        console.log(result);
        // this.setState({ isGettingWebform: false });

        let response = result; // result.data;
        if (response.ok) {
          let pages = this.state.pages;
          let bills = pages[this.state.page];
          bills[orderId] = response.bill;
          pages[this.state.page] = bills;
          this.setState({ pages: pages });
        } else {
          // this.showError(response.error);
          console.log("Error al recargar la factura", response.error);
        }
      })
      .catch((error) => {
        // Error 😨
          console.log("Error al recargar la factura", error);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  listReturnedBills(search) {
    this.props.userData.listReturnedBills(search).then(result => {
        // console.log("################## RESPUESTA OBTENER RETURNED BILLS ################");
        // console.log(result);
        // this.setState({ isGettingWebform: false });

        let response = result; // result.data;
        if (response.ok) {
          let pages = this.state.pages;
          if (!pages) pages = [];
          let page = search.page;
          if (!page) page = this.state.page;
          if (!page) page = 1;
          pages[search.page] = response.bills;
          this.setState({
            pages: pages,
            billsStatistics: response.billsStatistics
          });

          // this.setState({
          //   bills: response.bills,
          //   billsStatistics: response.billsStatistics
          // });
        } else {
          // this.showError(response.error);
          console.log("Error al obtener los datos de facturación", response.error);
        }
      })
      .catch((error) => {
        // Error 😨
          console.log("Error al obtener los datos de facturación", error);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  getGlobalBillingStatus(query) {
    this.props.userData.getGlobalBillingStatus(query).then(result => {
        // console.log("################## RESPUESTA OBTENER BILLING STATUS ################");
        // console.log(result);
        // this.setState({ isGettingWebform: false });

        let response = result; // result.data;
        if (response.ok) {
          this.setState({ billingStatus: response.billing_status });
        } else {
          // this.showError(response.error);
          console.log("Error al obtener los datos de facturación", response.error);
        }
      })
      .catch((error) => {
        // Error 😨
          console.log("Error al obtener los datos de facturación", error);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case ESTADO_FACTURA:
        return this.createBillStatusPopUp();
      case ENVIO:
        return this.createDeliveryPopUp();
      case NOTA:
        return this.createNotePopUp();
      case INTERNET:
        return this.configureInternetPopUp();
      case AGREGAR_MOVIL:
        return this.addMobilePopUp();
      case GASTO_EXTRA:
        return this.createExtraExpensePopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createBillStatusPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Editar estado"
        onConfirm={() => this.showPopUpConfirmation(ESTADO_FACTURA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Estado</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={this.props.mainState.billStatuses.forOptions}
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      case ESTADO_FACTURA:
        this.editBillStatusConfirmation();
        break;
      case ENVIO:
        this.newDeliverySIMConfirmation();
        break;
      case INTERNET:
        this.configureInternetConfirmation();
        break;
      case AGREGAR_MOVIL:
        this.addMobile();
        break;
      case GASTO_EXTRA:
        this.newExtraExpenseConfirmation();
        break;
      default:;
    }
  }
  editBillStatusConfirmation() {
    this.props.editBill(
      this.state.currentBillID,
      this.state.currentBillStatus.value,
      this.state.currentBillNumber
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Estado editado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El estado ha sido editado.
        </SweetAlert>
      )
    });
  }
  openBillStatusPopUpFromBill(order) {
    console.log("################## OPEN BILL STATUS ################");
    console.log(order);
    let billID = order.order_id;
    let billStatus = order.estado_pedido;
    let billNumber = order.numero_pedido;
    let _currentBillStatus = null;
    this.props.mainState.billStatuses.forOptions.map(currentStatus => {
      if (currentStatus.label === billStatus)
        _currentBillStatus = currentStatus;
    });
    this.setState({
      currentBillID: billID,
      currentBillStatus: _currentBillStatus,
      currentBillNumber: billNumber
    });
    this.showPopUp(ESTADO_FACTURA);
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      popUpConfirmation: null
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    /* if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{ */
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    /* } */
    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        })
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    let firstOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[0].fecha))
        .replace(".", "");
    let lastOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[partialOrders.length-1].fecha))
        .replace(".", "");

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart,
      ordersHistoryTitle: "Histórico de facturas (" + firstOrderDate + " - " + lastOrderDate + ")"
    });
  }
  downloadBill(url, orderNumber, event){
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(order){
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if(payment.includes("Pagada")){
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if(payment.includes("Procesando")){
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/{
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }

    statusReady =                   
    <Button
      color={statusButtonColor}
      size="sm"
      onClick={() => {this.openBillStatusPopUpFromBill(order)}}
    >
      <i className={statusButtonIcon} /> {payment}
    </Button>;

    return statusReady;
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  viewOrderArticles(order){
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>     
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }  
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  getViewArticlesButton(order) {
    let button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Ver
        </div>
      </Button>;

    if(true /*order in this.props.mainState.ordersArticles*/){
      button = 
      <Link to={"/facturas/".concat(order)}>
        <Button
          color="info"
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>;
    }

    return button;
  }
  searchBills() {
    if (!this.props.mainState.isSearchingBills)
      this.props.searchBills(this.state.searchQuery, this.state.currentPill === PILL_DEVUELTAS);
  }
  createNavigationPills() {
    // console.log("CHECK PERMISSION");
    // console.log(this.props.mainState);
    if (!PERMISSIONS.includes(parseInt(this.props.mainState.user.uid))) return null;
    return (
      <div>
        <Button
          round
          key={"pill1"}
          color={this.state.currentPill === PILL_TODAS ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_TODAS});
          }}
          leftLabel={"now-ui-icons business_money-coins"}
        >
          Todas
        </Button>
        {" "}
        <Button
          round
          key={"pill2"}
          color={this.state.currentPill === PILL_DEVUELTAS ? "danger" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_DEVUELTAS});
          }}
          leftLabel={"now-ui-icons tech_mobile"}
        >
          Devueltas
        </Button>
        {" "}
      </div>
    );
  }
  createSelectedPillContent() {
    let result = null;
    let ordersToDisplay = null;
    switch (this.state.currentPill) {
      case PILL_TODAS:
        ordersToDisplay = this.props.mainState.orders.slice(0);
        result = this.createBillsTable(ordersToDisplay);
        break;
      case PILL_DEVUELTAS:
        ordersToDisplay = this.props.mainState.orders.slice(0);
        result = this.createBillsTable(ordersToDisplay);
        break;
    }
    return result;
  }
  createBillsTable(ordersToDisplay) {
    let contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Últimas facturas</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  {thead.map((prop, key) => {
                    if (key === thead.length - 1)
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    if (this.state.currentPill === PILL_TODAS && prop === "Devolución") return null;
                    return <th key={key} className="text-center">{prop}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {ordersToDisplay.map((order, key) => {

                  let currentCustomer = null;
                  let currentCustomerLink = null;
                  // if (order.cliente_id in this.props.mainState.customers) {
                  // currentCustomer = this.props.mainState.customers[order.cliente_id][0];
                  currentCustomerLink = 
                    <Link to={"/clientes/fichas/".concat(order.cliente_id)}>
                      {order.nombre} {order.primer_apellido} {order.segundo_apellido}
                    </Link>;
                  // } else {
                  //   //if (!isSearchingCustomer) this.props.searchCustomer();
                  //   //isSearchingCustomer = true;
                  //   currentCustomerLink =                       
                  //     <div className="btns-mr-5">
                  //       <Button icon color="default" size="sm">
                  //         <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
                  //       </Button>
                  //     </div>;
                  // }
                  let overcharge = "";
                  if (!Array.isArray(order.fecha_devolucion)) {
                    overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
                  }
                  if (!Array.isArray(order.fecha_pago_devolucion)) {
                    overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
                  }
                  let unpaid_date = "";
                  if (this.state.currentPill === PILL_DEVUELTAS) {
                    try {
                      unpaid_date = order.fecha_devolucion ? order.fecha_devolucion.replace(/-/g,'/').split(" ")[0] : "";
                    } catch (error) {
                      unpaid_date = JSON.stringify(order.fecha_devolucion);
                    }
                  }
                  return (
                    <tr key={order.numero_pedido}>
                      <td className="text-center">{order.fecha}</td>
                      {this.state.currentPill === PILL_DEVUELTAS && <td className="text-center">{unpaid_date}</td>}
                      <td className="text-center">{currentCustomerLink}</td>
                      <td className="text-center">{order.numero_pedido}</td>
                      <td className="text-center">{order.total}{overcharge}</td>
                      <td className="text-center">    
                      {this.paymentStatus(order)} 
                      </td>
                      <td className="text-center">
                        <Button
                          color="danger"
                          size="sm"
                          onClick={e =>
                            this.downloadBill(order.enlace_pdf, order.numero_pedido, e)
                          }
                        >
                          {this.downloadButton(order.numero_pedido)}
                        </Button>{" "}
                        {this.getViewArticlesButton(order.numero_pedido)}                        
                      </td>
                      {/* order.data.map((prop, key) => {
                        if (key === thead.length - 1)
                          return (
                            <td key={key} className="text-right">
                              {prop}
                            </td>
                          );
                        return <td key={key}>{prop}</td>;
                      }) */}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>;
    return contentToDisplay;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  filterBills(bill) {
    if (!this.state.textFilter) return true;
    // let debtorText = JSON.stringify(debtor).toLowerCase();
    let textFilter = this.state.textFilter;
    let bill_json = "";
    // console.log("note_text", note_text);
    try {
      bill_json = JSON.stringify(bill).toLowerCase();
      // console.log("note_json", note_json);
      // note_text = note_json.text;
    } catch (error) {
      console.log("Error parsing debtor to JSON", { error: error, bill: bill });
      // note_text = note.texto;
    }

    let subFilters = textFilter.toLowerCase().split(" ");
    let result = true;
    if (!subFilters || subFilters.length === 0) {
      return result;
    }
    // console.log("subFilters",subFilters);
    subFilters.map(filter => {
      let localResult = false;
      if (bill_json.includes(filter)) localResult = true;
      // Si cualquiera de las condiciones se cumple, devuelve TRUE
      // if (note_text.toLowerCase().includes(filter)) localResult = true;
      // if (note.fecha.toLowerCase().includes(filter)) localResult = true;
      // if (note.tipo.toLowerCase().includes(filter)) localResult = true;
      // if (note_text.toLowerCase().includes(filter)) localResult = true;
      // if (note.autor.toLowerCase().includes(filter)) localResult = true;
      // if (note.titulo.toLowerCase().includes(filter)) localResult = true;

      result = result && localResult;
    });
    return result;
  }
  buildFilter() {
    let result = null;
    // if (this.state.pages && Object.keys(this.state.pages) > 0) {
    if (this.state.billsStatistics) {
      let statistics = this.state.billsStatistics;
      let pagesOptions = [];
      for (let i = 1; i <= statistics.total_pages; i++) {
        pagesOptions.push({
          value: i,
          label: i
        });
      }
      if (result === null) result = [];
      // result.push(<Select options={pagesOptions} value={this.state.page}></Select>);
      let pageSelect = (
        <Col xs={12}>
          <Form className="form-horizontal">
            <Row>
              <Col xs={12}><h5>{"Página " + this.state.page + " de " + statistics.total_pages}</h5></Col>
              <Col xs={6} md={3}>
                <Label xs={3} className="text-left">Página</Label>
                <FormGroup>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Página"
                    name="pagina"
                    value={{ value: this.state.page, label: this.state.page }}
                    options={pagesOptions}
                    onChange={value => this.setState({ page: value.value })}
                  />
                  <br></br>
                </FormGroup>
              </Col>
              <Col xs={6} md={3}>
                <Label md={3} className="text-left">Filtrar resultados</Label>
                <FormGroup>
                  <Input
                    type="text"
                    name="filtroTexto"
                    placeholder="Filtrar..."
                    value={this.state.textFilter}
                    onChange={event =>
                      this.setState({ textFilter: event.target.value })
                    }
                  />
                </FormGroup>
              </Col>
              <Col xs={6} md={3}>
                <Label xs={3} className="text-left">Elementos por página</Label>
                <FormGroup>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Elementos por página"
                    name="elementos_pagina"
                    value={{ value: this.state.pageItems, label: this.state.pageItems }}
                    options={ITEMS_PER_PAGE}
                    onChange={value => {
                      this.setState({
                        pageItems: value.value,
                        pages: [],
                        debtorsStatistics: null
                      });
                      let search = {
                        page: this.state.page,
                        page_items: value.value,
                        search: this.state.search
                      };
                      this.listReturnedBills(search);
                    }}
                  />
                  <br></br>
                </FormGroup>
              </Col>
              {/* <Col xs={12}><h5>Buscar</h5></Col>
              <Col xs={6} md={3}>
                <Label md={3} className="text-left">DNI/Nombre/Localidad...</Label>
                <FormGroup>
                  <Input
                    type="text"
                    name="search"
                    placeholder="Buscar..."
                    value={this.state.search}
                    onChange={event =>
                      this.setState({ search: event.target.value })
                    }
                    // filterOption={this.customFilter}
                  />
                  <Button
                    color={this.state.isSearchingDebtor ? "default" : "primary"}
                    round
                    icon
                    disabled={this.state.isSearchingDebtor || (!this.state.search || this.state.search.length < 3)}
                    onClick={() => {
                      // this.setState({
                      //   pageItems: value.value,
                      //   pages: [],
                      //   debtorsStatistics: null
                      // });
                      let search = {
                        page: this.state.page,
                        page_items: this.state.pageItems,
                        search: this.state.search
                      };
                      let isSearch = true;
                      this.listDebtors(search, isSearch);
                    }}
                  >
                    <i
                      className={
                        this.state.isSearchingDebtor
                          ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin"
                          : "now-ui-icons ui-1_zoom-bold"
                      }
                    />
                  </Button>
                </FormGroup>
              </Col> */}
            </Row>
          </Form>
        </Col>
      );
      result.push(pageSelect);
      result = (
        <Card>
          <CardBody>{result}</CardBody>
        </Card>
      );
    }
    // }
    return result;
  }
  createOrdersTable() {
    return (
      <BillsTable
        showCustomer
        bills={this.state.pages[this.state.page]}
        userData={this.props.userData}
        reloadEntityCallback={this.reloadOrder}
      />
    );
    let result = null;

    if (this.state.bills) {
      result = (
        <Table responsive className="styled-table">
          <thead>
            <tr className="text-primary">
              {thead.map((prop, key) => {
                if (prop === "Devolución") return null;
                if (prop === "Total") {
                  return [
                    <th key={"items"} className="text-center">{"Items"}</th>,
                    <th key={key} className="text-center">{prop}</th>
                  ];
                } else {
                  return <th key={key} className="text-center">{prop}</th>;
                }
              })}
            </tr>
          </thead>
          <tbody>
            {Object.keys(this.state.bills).map((order_id, key) => {
              let order = this.state.bills[order_id];
              let currentCustomer = null;
              let currentCustomerLink = null;
              // if (order.cliente_id in this.props.mainState.customers) {
              // currentCustomer = this.props.mainState.customers[order.cliente_id][0];
              currentCustomerLink = 
                <Link to={"/clientes/fichas/".concat(order.cliente_id)}>
                  {order.nombre} {order.primer_apellido} {order.segundo_apellido}
                </Link>;
              // } else {
              //   //if (!isSearchingCustomer) this.props.searchCustomer();
              //   //isSearchingCustomer = true;
              //   currentCustomerLink =                       
              //     <div className="btns-mr-5">
              //       <Button icon color="default" size="sm">
              //         <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
              //       </Button>
              //     </div>;
              // }
              let overcharge = "";
              if (!Array.isArray(order.fecha_devolucion)) {
                overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
              }
              if (!Array.isArray(order.fecha_pago_devolucion)) {
                overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
              }
              let unpaid_date = "";
              // if (this.state.currentPill === PILL_DEVUELTAS) {
                try {
                  unpaid_date = order.fecha_devolucion ? order.fecha_devolucion.replace(/-/g,'/').split(" ")[0] : "";
                } catch (error) {
                  unpaid_date = JSON.stringify(order.fecha_devolucion);
                }
              let items = (
                <Button
                  color="default"
                  size="sm"
                  style={{
                    display: "block",
                    width: "100%"
                  }}
                  onClick={() => {
                    let showItems = this.state.showItems;
                    if (showItems === order_id) {
                      showItems = null;
                    } else {
                      showItems = order_id;
                    }
                    this.setState({ showItems: showItems });
                  }}
                  leftLabel={"now-ui-icons shopping_box"}
                >
                  {order.line_items.count}
                </Button>
              );
              // }
              let currentOrderTr = (
                <tr key={order.numero_pedido} className={this.state.showItems === order_id ? "show-line-items active-row" : (this.state.showItems !== null ? "background-row" : "")}>
                  <td className="text-center">
                    {order.fecha}
                    {unpaid_date && unpaid_date !== "" ? (<span><br /><span className="item-related unpaid-date"><i className="now-ui-icons design_scissors" /> {unpaid_date}</span></span>) : null}
                  </td>
                  <td className="text-center">{currentCustomerLink}</td>
                  <td className="text-center">{order.numero_pedido}</td>
                  <td className="text-center">{items}</td>
                  <td className="text-center">{order.total}{overcharge}</td>
                  <td className="text-center">
                  {this.paymentStatus(order)} 
                  </td>
                  <td className="text-center">
                    <Button
                      color="danger"
                      size="sm"
                      onClick={e =>
                        this.downloadBill(order.enlace_pdf, order.numero_pedido, e)
                      }
                    >
                      {this.downloadButton(order.numero_pedido)}
                    </Button>{" "}
                    {this.getViewArticlesButton(order.numero_pedido)}
                  </td>
                  {/* order.data.map((prop, key) => {
                    if (key === thead.length - 1)
                      return (
                        <td key={key} className="text-right">
                          {prop}
                        </td>
                      );
                    return <td key={key}>{prop}</td>;
                  }) */}
                </tr>
              );
              if (this.state.showItems === order_id) {
                let itemsTr = null;
                itemsTr = Object.keys(order.line_items.line_items).map(item_id => {
                  let item = order.line_items.line_items[item_id];
                    return (
                      <tr key={order.numero_pedido + "-line_items-" + item_id}>
                        {/* <td className="text-left">{item.related}</td> */}
                        <td className="text-left">
                          <span className="item-name">{item.replaced_name}</span>
                          {item.related  && item.related !== "" ? (<span><br /><span className="item-related">{item.related}</span></span>) : null}
                        </td>
                        <td className="text-right">{item.total}</td>
                      </tr>
                    );
                });
                let itemsTable = (
                  <Table id="items-inside-orders" className="line-items-table styled-table">
                    {/* <thead>
                      <tr>
                        <th className="text-left">Relacionado</th>
                        <th className="text-left">Nombre</th>
                        <th className="text-right">Precio</th>
                      </tr>
                    </thead> */}
                    <tbody>{itemsTr}</tbody>
                  </Table>
                );
                let closeItemsButton = (
                  <Button
                    color="default"
                    size="sm"
                    style={{
                      display: "block",
                      width: "100%"
                    }}
                    onClick={() => {
                      this.setState({ showItems: null });
                    }}
                    leftLabel={"now-ui-icons ui-1_simple-remove"}
                  >
                    {"Cerrar"}
                  </Button>
                );
                let itemsTableInTr = (
                  <tr key={order.numero_pedido + "-line_items"} className="line-items-tr">
                    <td colspan="6">{itemsTable}</td>
                    <td style={{ display: "block" }}>{closeItemsButton}</td>
                  </tr>
                );
                return [currentOrderTr, itemsTableInTr, <tr key="tr-keep-odd-even"></tr>];
              } else {
                return currentOrderTr;
              }
            })}
          </tbody>
        </Table>
      );
    } else {
      result = (
        <div className="text-center">
          <i className="now-ui-icons arrows-1_refresh-69 spin" />{" Cargando facturas..."}
        </div>
      );
    }

    result = (
      <Col xs={12}>
        <h5>Facturas</h5>
        {result}
        {/* <Card>
          <CardHeader>
          </CardHeader>
          <CardBody>
          </CardBody>
        </Card> */}
      </Col>
    );
    return result;
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    // console.log("this.state.billingStatus",this.state.billingStatus);
    if (this.props.mainState.ordersLoaded && !this.state.ordersChartReady && this.props.mainState.orders.length > 0) this.loadOrdersChart();
    // let contentToDisplay = this.createOrdersTable();
    let ordersToDisplay = null;

    let buttonAttributes = {
      xs: 6,
      md: 4,
      lg: 3,
      className: "text-center hover-card",
      // style: {
      // }
    };
    let filterField = this.buildFilter();
    let content = null;
    if (this.state.pages && this.state.pages[this.state.page]) {
      let bills = this.state.pages[this.state.page];
      let filtered_bills = [];
      Object.keys(bills).map(id => {
        let bill = bills[id];
        if (this.filterBills(bill)) filtered_bills[id] = bill;
      });
      content = (
        <BillsTable
          showCustomer
          bills={filtered_bills}
          userData={this.props.userData}
          reloadEntityCallback={this.reloadOrder}
        />
      );
    } else {
      content = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando datos...</span>;
    }
    return (
      <div>
      <PanelHeader
        size="sm"
      />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          {/* <Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input type="text" 
                    placeholder="Buscar factura..."
                    value={this.state.searchQuery}
                    onChange={(e) => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if(e.keyCode == 13){
                        //Enter is key code 13
                        this.searchBills();
                        // put the login here
                      }
                    }}
                    style={{marginRight:"10px"}}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingBills
                        ? "default"
                        : "primary"
                    }
                    round 
                    icon 
                    onClick={this.searchBills}>
                <i className={this.props.mainState.isSearchingBills?
                                      "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_zoom-bold"} />
              </Button>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
          <Row>
            <Col {...buttonAttributes}>
              <Card>
                <CardBody>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="design_scissors"
                    title={this.state.billingStatus ? this.state.billingStatus.returned.formatted : <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando datos...</span>}
                    subtitle={"Devueltas sin pagar" + (this.state.billingStatus ? " (" + this.state.billingStatus.returned.ratio_text + ")" : "")}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col {...buttonAttributes}>
              <Card onClick={() => this.redirectTo("/facturas/morosos")}>
                <CardBody>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="design_scissors"
                    title="Morosos"
                    subtitle="Lista de morosos"
                  />
                </CardBody>
              </Card>
            </Col>
            {/* {this.state.showDetail && orderArticles} */}
            {/* {navigationPills} */}
            <Col xs={12}>
              <h5>Facturas</h5>
            </Col>
            <Col xs={12}>{filterField}</Col>
            <Col xs={12}>
              {content}
            </Col>
            <Col xs={12}>{filterField}</Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default BillsReturnedList;



// WEBPACK FOOTER //
// ./src/views/Bills/BillsReturnedList.jsx